module.exports = __webpack_public_path__ + "img/nominee-details-active.d1b4d76a.svg";